export const tests ={
  AI_NUX_CONTROL: 'da',
  AI_NUX_TESTER: 'db',
  CAREGIVER_PAYWALL_STRIPE_PAYMENT: 'disabled', // WEB-12681: Temporarily disable 'cz' test group
};
